import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { TextInputBox } from '../Box/TextInputBox';
import { LabelBox } from '../Box/LabelBox';
import { axiosInstance } from '../../functions/axios';
import CustomerLogo from '../CustomerLogo/CustomerLogo';
import { useDispatch } from 'react-redux';
import { setCaptchaHeader } from '../../actions/index';
import { NativeDropdown } from '../NativeDropdown/NativeDropdown';
import { NativeCheckbox } from '../NativeCheckbox/NativeCheckbox';
import { InlineNotificationComponent } from '../Notification/InlineNotificationComponent';
import './GuestRegistration.css';

import { Box, Button, Checkbox, Grid, Icon, InlineNotification, TextInput, Typography, Field, FieldLabel } from '@blueprint/ui';

import { makeStyles } from '@material-ui/core/styles';

const StyledDiv = styled.div`
    padding-top: 100px;
    padding-right: 5vw;
    padding-left: 5vw;
    padding-bottom: 5em;
`;

const StyledLink = styled(Link)`
    color: black;
    font-weight: bold;

    &:hover {
        text-decoration: underline;
        cursor: pointer;
        color: black;
    }
`;

const useStyles = makeStyles({
    labelBox: {},
});

const GuestRegistration = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const history = useHistory();
    const [userEmail, setUserEmail] = useState('');
    const [userName, setUserName] = useState('');
    const [userMobile, setUserMobile] = useState('');
    const [userMobileConfirm, setUserMobileConfirm] = useState('');
    const [userCountryCode, setUserCountryCode] = useState('');
    const [checkMobilePresent, setCheckMobilePresent] = useState('');
    const [newMobile, setNewMobile] = useState('');
    const [confirmMobile, setConfirmMobile] = useState('');
    const [newISD, setNewISD] = useState('');
    const [confirmISD, setConfirmISD] = useState('');
    const [showMobileError, setShowMobileError] = useState(false);
    const [mobileError, setMobileError] = useState('');
    const [mobileVerified, setMobileVerified] = useState(false);
    const [otp, setOtp] = useState('');
    const [showOtpError, seShowOtpError] = useState(false);
    const [verifyDisable, setVerifyDisable] = useState(true);
    const [countryCodes, setCountryCodes] = useState([]);
    const [showConfirmFields, setShowConfirmFields] = useState(true);
    const [custId, setCustId] = useState(null);

    const FETCH_USER_DETAILS_URL = process.env.REACT_APP_FETCH_USER_DETAILS_URL;
    const VALIDATE_MOBILE_URL = process.env.REACT_APP_VALIDATE_MOBILE_URL;
    const FETCH_ISD_CODES_URL = process.env.REACT_APP_FETCH_ISD_CODES_URL;
    const SEND_OTP_URL = process.env.REACT_APP_SEND_OTP_URL;
    const VERIFY_OTP_URL = process.env.REACT_APP_VERIFY_OTP_URL;

    const globalState = useSelector((state) => state);

    const footerHeight = globalState.beneDetails.footerHeight;

    useEffect(() => {
        dispatch(setCaptchaHeader(null));
    }, [dispatch]);

    useEffect(() => {
        if (!globalState.beneDetails.details.isLogged || globalState.beneDetails.registeredUser) {
            history.push('/');
        }
    }, [globalState, history]);

    useEffect(() => {
        const callUserDetails = async () => {
            const response = await axiosInstance.post(FETCH_USER_DETAILS_URL);
            if (response) {
                const responseJson = response.data;
                console.log(`Logging ${FETCH_USER_DETAILS_URL} API Response`, responseJson);

                if (response.status !== 200) {
                } else {
                    setCustId(responseJson.custId);
                    setUserEmail(responseJson.userId);
                    setUserName(responseJson.name);
                    setUserMobile(responseJson.maskedMobileNo);
                    setUserMobileConfirm(responseJson.mobileConfirmation);
                    setUserCountryCode(responseJson.mobileCountryCode);
                }
            }
        };

        if (globalState.beneDetails.details.emailId !== '') {
            callUserDetails();
        }
    }, [FETCH_USER_DETAILS_URL]);

    useEffect(() => {
        if (userName !== '') {
            if (userMobile === null || userMobile.trim() === '') {
                setCheckMobilePresent(false);
            } else {
                setCheckMobilePresent(true);
            }
        }
    }, [globalState, userEmail, userName, checkMobilePresent, userMobile]);

    useEffect(() => {
        const fetchISD = async () => {
            const response = await axiosInstance({
                method: 'get',
                url: FETCH_ISD_CODES_URL,
                params: {
                    custId: custId,
                },
            });
            const responseJSON = response.data;
            setCountryCodes(
                responseJSON.map((country) => ({
                    label: country.shortName + '-' + country.isdCode,
                    value: country.isdCode,
                }))
            );
        };

        if (globalState.beneDetails.details.emailId !== '' && custId !== null) {
            fetchISD();
        }
    }, [FETCH_ISD_CODES_URL, custId]);

    const handleISD = (SelectedOption, event) => {
        validateIsd(SelectedOption.value);
        setGuestRegistrationDetails({ ...guestRegistrationDetails, isd: SelectedOption.value });
    };

    const handleConfirmISD = (SelectedOption, event) => {
        validateConfirmationIsd(SelectedOption.value);
        setGuestRegistrationDetails({ ...guestRegistrationDetails, confirmationIsd: SelectedOption.value });
    };

    const validateMobileError = () => {
        if (confirmMobile === '' || confirmMobile === null) {
            setShowMobileError(true);
            setMobileError(t('guestUserPage.error'));
        } else {
            setShowMobileError(false);
            if (updateTick) {
                setupdateDisable(false);
            }
        }
    };

    const validateMobile = () => {
        if (confirmMobile !== null && confirmMobile !== '') {
            const callValidateMobile = async () => {
                try {
                    const response = await axiosInstance.post(
                        VALIDATE_MOBILE_URL,
                        JSON.stringify({
                            confirmMobileCntryCd: userCountryCode,
                            confirmMobileNo: confirmMobile,
                        })
                    );

                    if (response.status === 200) {
                        console.log(`Logging ${VALIDATE_MOBILE_URL} success`, response.data);
                        setMobileVerified(true);
                    }
                } catch (error) {
                    console.error(`Logging ${VALIDATE_MOBILE_URL} error`, error.response);
                    if (error && error.response && error.response.status === 400) {
                        setMobileError(t('guestUserPage.user_error_001'));
                        setShowMobileError(true);
                    }
                }
            };
            callValidateMobile();
        } else {
            let elementsWithError = document.getElementsByClassName('hasError');
            setTimeout(() => {
                if (elementsWithError !== null && elementsWithError !== undefined && elementsWithError.length > 0) {
                    console.log('Logging first element having class hasError', elementsWithError[0]);
                    elementsWithError[0].focus();
                }
            }, 200);
        }
    };

    const sendOtp = () => {
        setShowConfirmFields(false);
        setShowMobileError(false);
        setShowPasswordVerification(true);
        const callSendOtp = async () => {
            try {
                const response = await axiosInstance({
                    method: 'post',
                    url: SEND_OTP_URL,
                    data: JSON.stringify({
                        mobileCntryCd: guestRegistrationDetails.isd,
                        mobileNo: guestRegistrationDetails.number,
                    }),
                });
                console.log(`Success response from ${SEND_OTP_URL}`, response);
            } catch (error) {
                console.log(`Error response from ${SEND_OTP_URL}`, error);
            }
        };
        callSendOtp();
    };

    const [guestRegistrationDetails, setGuestRegistrationDetails] = useState({
        isd: '',
        confirmationIsd: '',
        number: '',
        confirmationNumber: '',
    });

    const [errorFlags, setErrorFlags] = useState({
        isd: false,
        confirmationIsd: false,
        number: false,
        confirmationNumber: false,
    });

    const [errorMessages, setErrorMessages] = useState({
        isd: '',
        confirmationIsd: '',
        number: '',
        confirmationNumber: '',
    });

    const allValuesEntered = () => {
        for (let x in guestRegistrationDetails) {
            if (guestRegistrationDetails[x].trim() === '') {
                console.log(`${guestRegistrationDetails[x]} is empty`);
                return false;
            }
        }
        return true;
    };

    useEffect(() => {
        const enableSendOtpButton = () => {
            console.log('User entered values are ', guestRegistrationDetails);
            console.log('Error flags are', errorFlags);
            console.log('Error messages are', errorMessages);

            let errorsExist = false;

            // Check if any error exists
            for (let x in errorFlags) {
                if (errorFlags[x] === true) {
                    errorsExist = true;
                    console.log('Wont enable Send OTP button as error(s) exist');
                }
            }

            // If errors exist then disable button and show error component
            if (errorsExist) {
                console.log('Showing error message');

                // Ensure that 'Send OTP' button is disabled
                setVerifyDisable(true);

                // Choose the error message to show
                finalMobileError();

                // Make Inline error component visible
                setShowMobileError(true);
            }

            // If no errors exist
            if (!errorsExist) {
                console.log('Removing error message');

                // Remove error message and error component
                setShowMobileError(false);
                setMobileError('');
            }

            // If all error flags are false and values have been entered
            if (!errorsExist && allValuesEntered()) {
                console.log('Enabling Send OTP button');

                // Ensure that button is enabled
                setVerifyDisable(false);
            }
        };
        enableSendOtpButton();
    }, [errorFlags]);

    const validateIsd = (isd) => {
        if (isd === null || isd.trim() === '') {
            console.log('ISD cannot be empty');
            setErrorFlags({ ...errorFlags, isd: true });
            setErrorMessages({ ...errorMessages, isd: t('guestUserPage.isdEmpty') });
        } else if (isd !== guestRegistrationDetails.confirmationIsd) {
            if (guestRegistrationDetails.confirmationIsd !== '') {
                console.log('ISD and confirm ISD dont match');
                setErrorFlags({ ...errorFlags, isd: true });
                setErrorMessages({ ...errorMessages, isd: t('guestUserPage.isd_error') });
            }
        } else if (isd === guestRegistrationDetails.confirmationIsd && guestRegistrationDetails.confirmationIsd !== '') {
            console.log('isd validated, Remove ISD error');
            setErrorFlags({ ...errorFlags, isd: false, confirmationIsd: false });
            setErrorMessages({ ...errorMessages, isd: '', confirmationIsd: '' });
        }
    };

    const validateConfirmationIsd = (confirmationIsd) => {
        if (confirmationIsd === null || confirmationIsd.trim() === '') {
            console.log('confirmationIsd cannot be empty');
            setErrorFlags({ ...errorFlags, confirmationIsd: true });
            setErrorMessages({ ...errorMessages, confirmationIsd: t('guestUserPage.isdEmpty') });
        } else if (confirmationIsd !== guestRegistrationDetails.isd) {
            if (guestRegistrationDetails.isd !== '') {
                console.log('confirmationIsd and ISD dont match');
                setErrorFlags({ ...errorFlags, confirmationIsd: true });
                setErrorMessages({ ...errorMessages, confirmationIsd: t('guestUserPage.isd_error') });
            }
        } else if (confirmationIsd === guestRegistrationDetails.isd && guestRegistrationDetails.isd !== '') {
            console.log('confirmationIsd validated, Remove confirmationIsd error');
            setErrorFlags({ ...errorFlags, confirmationIsd: false, isd: false });
            setErrorMessages({ ...errorMessages, confirmationIsd: '', isd: '' });
        }
    };

    const validateNumber = (number) => {
        if (number === null || number.trim() === '') {
            console.log('number cannot be empty');
            setErrorFlags({ ...errorFlags, number: true });
            setErrorMessages({ ...errorMessages, number: t('guestUserPage.numberEmpty') });
        } else if (number.trim() !== guestRegistrationDetails.confirmationNumber.trim()) {
            if (guestRegistrationDetails.confirmationNumber.trim() !== '') {
                console.log('number and confirmationNumber dont match');
                setErrorFlags({ ...errorFlags, number: true });
                setErrorMessages({ ...errorMessages, number: t('guestUserPage.mobile_error') });
            }
        } else if (
            number.trim() === guestRegistrationDetails.confirmationNumber.trim() &&
            guestRegistrationDetails.confirmationNumber.trim() !== ''
        ) {
            console.log('number validated, Remove error');
            setErrorFlags({ ...errorFlags, number: false, confirmationNumber: false });
            setErrorMessages({ ...errorMessages, number: '', confirmationNumber: '' });
        }
    };

    const validateConfirmationNumber = (confirmationNumber) => {
        if (confirmationNumber === null || confirmationNumber.trim() === '') {
            console.log('confirmationIsd cannot be empty');
            setErrorFlags({ ...errorFlags, confirmationNumber: true });
            setErrorMessages({ ...errorMessages, confirmationNumber: t('guestUserPage.numberEmpty') });
        } else if (confirmationNumber.trim() !== guestRegistrationDetails.number.trim()) {
            if (guestRegistrationDetails.number.trim() !== '') {
                console.log('number and confirmationNumber dont match');
                setErrorFlags({ ...errorFlags, confirmationNumber: true });
                setErrorMessages({ ...errorMessages, confirmationNumber: t('guestUserPage.mobile_error') });
            }
        } else if (confirmationNumber.trim() === guestRegistrationDetails.number.trim() && guestRegistrationDetails.number.trim() !== '') {
            console.log('confirmationNumber validated, Remove error');
            setErrorFlags({ ...errorFlags, confirmationNumber: false, number: false });
            setErrorMessages({ ...errorMessages, confirmationNumber: '', number: '' });
        }
    };

    const finalMobileError = () => {
        if (errorMessages.isd !== '') {
            setMobileError(errorMessages.isd);
        } else if (errorMessages.confirmationIsd !== '') {
            setMobileError(errorMessages.confirmationIsd);
        } else if (errorMessages.number !== '') {
            setMobileError(errorMessages.number);
        } else if (errorMessages.confirmationNumber !== '') {
            setMobileError(errorMessages.confirmationNumber);
        }
    };

    const verifyOtp = () => {
        if (otp.trim() === '') {
            seShowOtpError(true);
            setMobileError(t('guestUserPage.pleaseEnterPassword'));
            return;
        }
        const callVerifyOtp = async () => {
            try {
                const response = await axiosInstance({
                    method: 'post',
                    url: VERIFY_OTP_URL,
                    data: JSON.stringify({
                        mobileCntryCd: guestRegistrationDetails.isd,
                        mobileNo: guestRegistrationDetails.number,
                        otp: otp,
                    }),
                });
                if (response.status === 200) {
                    seShowOtpError(false);
                    setMobileVerified(true);
                    setShowPasswordVerification(false);
                    setShowConfirmFields(false);
                }
            } catch (error) {
                if (error && error.response && error.response.status === 400) {
                    seShowOtpError(true);
                    setMobileError(error.response.data.message);
                }
            }
        };
        if (otp !== '') {
            callVerifyOtp();
        }
    };

    const [showPasswordVerification, setShowPasswordVerification] = useState(false);

    // For Confirm Checkbox
    const [updateTick, setUpdateTick] = useState(false);
    const [updateDisable, setupdateDisable] = useState(true);

    const handleTick = (event) => {
        setUpdateTick(event.target.checked);
        if (mobileVerified || userMobileConfirm || checkMobilePresent === false) {
            setupdateDisable(!event.target.checked);
        }
    };
    const { t } = useTranslation();

    const isNumber = (character) => {
        const numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        if (numbers.includes(character)) {
            console.log(`${character} is a number`);
            return true;
        } else {
            console.log(`${character} is not a number`);
            return false;
        }
    };

    /**
     * Mobile Number  |91|  |*******789| Tick
     *
     */
    const mobilePresentJSX = (
        <>
            <Grid container>
                <Field name='gr-textbox-mobile'>
                    <Grid item xs={12} sm={2}>
                        <LabelBox>
                            <FieldLabel variant='body1' aria-label='Mobile number'>
                                {t('guestUserPage.mobile_no')}
                            </FieldLabel>
                        </LabelBox>
                    </Grid>
                    <Grid item xs={2} sm={1} md={1} lg={1} xl={1} style={{ paddingRight: '8px' }}>
                        <TextInputBox>
                            <TextInput id='gr-textbox-isd' value={userCountryCode} disabled />
                        </TextInputBox>
                    </Grid>
                    <Grid item xs={9} sm={4} md={2} lg={3} xl={3}>
                        <TextInputBox>
                            <TextInput value={userMobile} disabled />
                        </TextInputBox>
                    </Grid>
                </Field>
                <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <Box marginTop={['15px', '15px', '15px', '33px']} marginLeft={['10px', '10px', '10px', '10px']}>
                        <Icon name='StatusConfirmationLight' aria-label='Mobile number confirmed' />
                    </Box>
                </Grid>
            </Grid>
        </>
    );

    /**
     * Confirm Mobile Number
     *                      |91|    |*******210|
     */

    /**
     * Confirm Mobile Number
     *                      |91|    |*******210|
     *                      |91|    |__________|
     */
    const mobilePresentConfirmJSX = (
        <>
            <Grid container>
                <Field name='gr-textbox-mobile'>
                    <Grid item xs={12} sm={2}>
                        <LabelBox>
                            <FieldLabel variant='body1'>{t('guestUserPage.mobile_no')}</FieldLabel>
                        </LabelBox>
                    </Grid>
                    <Grid item xs={2} sm={1} md={1} lg={1} xl={1} style={{ paddingRight: '8px' }}>
                        <TextInputBox>
                            <TextInput id='gr-textbox-isd' value={userCountryCode} disabled />
                        </TextInputBox>
                    </Grid>
                    <Grid item xs={9} sm={4} md={2} lg={3} xl={3}>
                        <TextInputBox>
                            <TextInput value={userMobile} disabled />
                        </TextInputBox>
                    </Grid>
                </Field>
                {mobileVerified ? (
                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                        <Box marginTop={['15px', '15px', '15px', '33px']} marginLeft={['5px', '5px', '5px', '10px']}>
                            <Icon name='StatusConfirmationLight' aria-label='statuscl' />
                        </Box>
                    </Grid>
                ) : null}
            </Grid>
            {mobileVerified ? null : (
                <>
                    <Grid container>
                        <Field name='gr-textbox-mobile-confirm'>
                            <Grid item xs={12} sm={2}>
                                <LabelBox>
                                    <FieldLabel variant='body1'>{t('guestUserPage.confirm_mobile_no')}*</FieldLabel>
                                </LabelBox>
                            </Grid>
                            <Grid item xs={2} sm={1} md={1} lg={1} xl={1} style={{ paddingRight: '8px' }}>
                                <TextInputBox>
                                    <TextInput id='gr-textbox-isd-confirm' value={userCountryCode} />
                                </TextInputBox>
                            </Grid>
                            <Grid item xs={9} sm={4} md={2} lg={3} xl={3}>
                                <TextInputBox>
                                    <TextInput
                                        className={showMobileError ? 'hasError' : ''}
                                        placeholder={t('guestUserPage.pl_mobile_confirm')}
                                        value={confirmMobile}
                                        onChange={(event) => {
                                            setConfirmMobile(event.value);
                                        }}
                                        onBlur={() => {
                                            validateMobileError();
                                        }}
                                        aria-describedby='gr-inline-error-mobile-confirm'
                                        autoFocus
                                    />
                                </TextInputBox>
                            </Grid>
                        </Field>

                        {showMobileError ? (
                            <Grid container>
                                <Grid item xs={6} sm={2}></Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <InlineNotificationComponent id='gr-inline-error-mobile-confirm' title='' content={mobileError} />
                                </Grid>
                            </Grid>
                        ) : null}
                    </Grid>

                    <Grid container>
                        <Grid item xs={12} sm={2}></Grid>
                        <Grid item md={3}>
                            <Box marginBottom={3} marginTop={['5px', '5px', '5px', '15px']}>
                                <Button
                                    id='gr-button-validate-mobile'
                                    style={{
                                        width: '100%',
                                        justifyContent: 'center',
                                    }}
                                    variant='light.tertiary'
                                    onClick={() => {
                                        validateMobile();
                                    }}
                                >
                                    {t('guestUserPage.button')}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </>
            )}
        </>
    );

    /**
     * Mobile Number                    |__| |__________|
     * Confirm Mobile Number            |__| |__________|
     *                                  |Mobile Number Does not Match|
     *                                  |Mobile Number Verification Password|
     */

    const mobileNotPresentJSX = (
        <>
            {showConfirmFields ? (
                <>
                    <Grid container>
                        <Field name='gr-textbox-mobile'>
                            <Grid item xs={12} sm={2}>
                                <LabelBox>
                                    <FieldLabel variant='body1' id='gr-textbox-mobile'>
                                        {t('guestUserPage.mobile_no')}
                                    </FieldLabel>
                                </LabelBox>
                            </Grid>
                            <Grid item xs={12} sm={2} md={2} lg={2} xl={2} style={{ paddingRight: '8px' }}>
                                <TextInputBox>
                                    <NativeDropdown
                                        id='gr-textbox-isd'
                                        width='102%'
                                        options={countryCodes}
                                        onChange={handleISD}
                                        autoFocus
                                        ariaLabelledby='gr-textbox-mobile'
                                        ariaDescribedby='gr-inline-error-mobile-confirm'
                                    />
                                    {/**<ReactSelect
                                        id='gr-textbox-isd'
                                        width='102%'
                                        isSearchable
                                        options={countryCodes}
                                        onChange={handleISD}
                                        value={newISD}
                                        autoFocus
                                    /> */}
                                </TextInputBox>
                            </Grid>
                            <Grid item xs={12} sm={2} md={2} lg={2} xl={2}>
                                <TextInputBox>
                                    <TextInput
                                        placeholder={t('guestUserPage.pl_mobile')}
                                        value={guestRegistrationDetails.number}
                                        newMobile
                                        onChange={(event) => {
                                            if (event.value.trim() !== '') {
                                                // Convert string to array
                                                let number = event.value.split('');
                                                console.log('Entered number is', number);

                                                // Remove non numbers from array
                                                let filteredNumber = number.filter((character) => isNumber(character));
                                                console.log('Filtered number is', filteredNumber);

                                                // Convert array to string
                                                let filteredNumberString = filteredNumber.join('');
                                                validateNumber(filteredNumberString);
                                                setGuestRegistrationDetails({ ...guestRegistrationDetails, number: filteredNumberString });
                                            } else {
                                                validateNumber(event.value);
                                                setGuestRegistrationDetails({ ...guestRegistrationDetails, number: '' });
                                            }
                                        }}
                                    />
                                </TextInputBox>
                            </Grid>
                        </Field>
                    </Grid>

                    <Grid container>
                        <Field name='gr-textbox-mobile-confirm'>
                            <Grid item xs={12} sm={2}>
                                <LabelBox>
                                    <FieldLabel variant='body1' id='gr-textbox-mobile-confirm'>
                                        {t('guestUserPage.confirm_mobile_no')}
                                    </FieldLabel>
                                </LabelBox>
                            </Grid>
                            <Grid item xs={12} sm={2} md={2} lg={2} xl={2} style={{ paddingRight: '8px' }}>
                                <TextInputBox>
                                    <NativeDropdown
                                        id='gr-textbox-isd-confirm'
                                        width='102%'
                                        options={countryCodes}
                                        onChange={handleConfirmISD}
                                        ariaLabelledby='gr-textbox-mobile-confirm'
                                        ariaDescribedby='gr-inline-error-mobile-confirm'
                                    />
                                    {/**                                    <ReactSelect
                                        id='gr-textbox-isd-confirm'
                                        width='102%'
                                        isSearchable
                                        options={countryCodes}
                                        onChange={handleConfirmISD}
                                        value={confirmISD}
                                    /> */}
                                </TextInputBox>
                            </Grid>
                            <Grid item xs={12} sm={2} md={2} lg={2} xl={2}>
                                <TextInputBox>
                                    <TextInput
                                        aria-describedby='gr-inline-error-mobile-confirm'
                                        className={showMobileError ? 'hasError' : ''}
                                        placeholder={t('guestUserPage.pl_mobile_confirm')}
                                        value={guestRegistrationDetails.confirmationNumber}
                                        onChange={(event) => {
                                            if (event.value.trim() !== '') {
                                                // Convert string to array
                                                let number = event.value.split('');
                                                console.log('Entered number is', number);

                                                // Remove non numbers from array
                                                let filteredNumber = number.filter((character) => isNumber(character));
                                                console.log('Filtered number is', filteredNumber);

                                                // Convert array to string
                                                let filteredNumberString = filteredNumber.join('');
                                                validateConfirmationNumber(filteredNumberString);
                                                setGuestRegistrationDetails({
                                                    ...guestRegistrationDetails,
                                                    confirmationNumber: filteredNumberString,
                                                });
                                            } else {
                                                validateConfirmationNumber(event.value);
                                                setGuestRegistrationDetails({ ...guestRegistrationDetails, confirmationNumber: '' });
                                            }
                                        }}
                                    />
                                </TextInputBox>
                            </Grid>
                        </Field>
                    </Grid>
                    {showMobileError ? (
                        <Grid container>
                            <Grid item xs={12} sm={2}></Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <InlineNotificationComponent id='gr-inline-error-mobile-confirm' title='' content={mobileError} />
                            </Grid>
                        </Grid>
                    ) : null}

                    <Grid container>
                        <Grid item xs={12} sm={2}></Grid>
                        <Grid item md={4}>
                            <Box marginBottom={3} marginTop={['5px', '5px', '5px', '15px']}>
                                <Button
                                    id='gr-button-send-otp'
                                    style={{
                                        width: '100%',
                                        justifyContent: 'center',
                                    }}
                                    variant='light.tertiary'
                                    onClick={() => {
                                        sendOtp();
                                    }}
                                    disabled={verifyDisable}
                                >
                                    {t('guestUserPage.verifybutton')}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </>
            ) : null}
            {showConfirmFields ? null : (
                <Grid container>
                    <Field name='gr-textbox-mobile'>
                        <Grid item xs={12} sm={2}>
                            <LabelBox>
                                <FieldLabel variant='body1'>{t('guestUserPage.mobile_no')}</FieldLabel>
                            </LabelBox>
                        </Grid>
                        <Grid item xs={2} sm={1} md={1} lg={1} xl={1} style={{ paddingRight: '8px' }}>
                            <TextInputBox>
                                <TextInput id='gr-textbox-isd' value={guestRegistrationDetails.isd} disabled />
                            </TextInputBox>
                        </Grid>
                        <Grid item xs={9} sm={4} md={4} lg={3} xl={3}>
                            <TextInputBox>
                                <TextInput value={guestRegistrationDetails.number} disabled />
                            </TextInputBox>
                        </Grid>
                        {mobileVerified ? (
                            <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                                <Box marginTop={['15px', '15px', '15px', '33px']} marginLeft={['5px', '5px', '5px', '10px']}>
                                    <Icon name='StatusConfirmationLight' aria-label='statuscl' />
                                </Box>
                            </Grid>
                        ) : null}
                    </Field>
                </Grid>
            )}
        </>
    );

    /**
     * Please input the password which has been E-mailed/SMS to you to register your mobile number
     *             ___________           _________________
     * Password : |___________|         |_____CONFIRM_____|
     *
     */
    const passwordVerificationJSX = (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Box marginTop={['5px', '5px', '5px', '15px']}>
                        <Typography variant='body1'>{t('guestUserPage.password_label')}</Typography>
                    </Box>
                </Grid>
                <Field name='gr-textbox-otp'>
                    <Grid item xs={12} sm={2}>
                        <LabelBox>
                            <FieldLabel variant='body1'>{t('guestUserPage.password')}</FieldLabel>
                        </LabelBox>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                        <TextInputBox>
                            <TextInput
                                type='password'
                                value={otp}
                                onChange={(event) => {
                                    setOtp(event.value);
                                }}
                                autoFocus
                            />
                        </TextInputBox>
                    </Grid>
                </Field>
                {showOtpError ? (
                    <Grid container>
                        <Grid item xs={6} sm={1}></Grid>
                        <Grid item xs={12} sm={3} md={3}>
                            <InlineNotificationComponent id='gr-inline-error-otp' title='' content={mobileError} />
                        </Grid>
                    </Grid>
                ) : null}
            </Grid>

            <Grid container>
                <Grid item xs={12} sm={2}></Grid>
                <Grid item xs={12} sm={10}>
                    <Box display='flex' flexDirection='row'>
                        <Box marginTop={['10px', '10px', '10px', '24px']} marginRight={['0px', '0px', '1px', '5px']}>
                            <Button
                                id='gr-button-confirm-otp'
                                variant='light.tertiary'
                                onClick={() => {
                                    verifyOtp();
                                }}
                            >
                                <Typography variant='body1' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', textAlign: 'center' }}>
                                    {t('guestUserPage.confirm_button')}
                                </Typography>
                            </Button>
                        </Box>

                        <Box marginTop={['10px', '10px', '10px', '24px']} marginLeft={['0px', '0px', '1px', '5px']}>
                            <Button
                                id='gr-button-resend-otp'
                                variant='light.tertiary'
                                onClick={() => {
                                    sendOtp();
                                }}
                            >
                                <Typography variant='body1' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', textAlign: 'center' }}>
                                    {t('guestUserPage.resend_button')}
                                </Typography>
                            </Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </>
    );

    const passwordVerification = showPasswordVerification ? passwordVerificationJSX : null;

    return (
        <StyledDiv role='main' style={{ paddingBottom: `${footerHeight + 20}px` }}>
            <Grid container>
                <CustomerLogo />
                <Grid container>
                    <Box borderLeft='3px solid red' paddingLeft='10px'>
                        <Typography variant='h1' className='page-title' tabIndex='-1'>
                            {t('guestUserPage.title')}
                        </Typography>
                    </Box>
                </Grid>
                <Grid container>
                    <Box marginTop={['10px', '10px', '10px', '24px']}>
                        <Typography variant='h2'>{t('guestUserPage.section_title')}</Typography>
                    </Box>
                </Grid>
                <Grid container>
                    <Box marginTop={['5px', '5px', '5px', '15px']} maxWidth='600px' wordWrap='break-word'>
                        <Typography variant='body1'>{t('guestUserPage.terms_label')}</Typography>
                    </Box>
                </Grid>
                <Grid container>
                    <Field name='gr-textbox-username'>
                        <Grid item xs={12} sm={2}>
                            <LabelBox>
                                <FieldLabel variant='body1'>{t('guestUserPage.name')}</FieldLabel>
                            </LabelBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextInputBox>
                                <TextInput value={userName} disabled />
                            </TextInputBox>
                        </Grid>
                    </Field>
                </Grid>
                <Grid container>
                    <Field name='gr-textbox-email'>
                        <Grid item xs={12} sm={2}>
                            <LabelBox>
                                <FieldLabel variant='body1'>{t('guestUserPage.email')}</FieldLabel>
                            </LabelBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextInputBox>
                                <TextInput value={userEmail} disabled />
                            </TextInputBox>
                        </Grid>
                    </Field>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Box marginTop={['10px', '10px', '24px', '24px']}>
                        <Typography variant='h2'>
                            {checkMobilePresent
                                ? userMobileConfirm
                                    ? t('guestUserPage.mobileNotPresent')
                                    : t('guestUserPage.mobilePresentConfirm')
                                : t('guestUserPage.mobileNotPresent')}
                        </Typography>
                    </Box>
                </Grid>
                <Grid container>
                    <Grid item>
                        <Box marginTop={['10px', '10px', '10px', '15px']} maxWidth='600px' wordWrap='break-word'>
                            <Typography variant='body1'>
                                {checkMobilePresent
                                    ? userMobileConfirm
                                        ? t('guestUserPage.mobilePresentConfirmParagraph')
                                        : t('guestUserPage.mobilePresentConfirmParagraph')
                                    : t('guestUserPage.register_label')}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
                {checkMobilePresent ? (userMobileConfirm ? mobilePresentJSX : mobilePresentConfirmJSX) : mobileNotPresentJSX}
                {passwordVerification}
                <Grid container>
                    <Grid item xs={12} md={12}>
                        <Box display='flex' flexDirection='column' marginTop={['10px', '10px', '24px', '24px']} paddingBottom='10px'>
                            <Box>
                                <NativeCheckbox
                                    id='gr-tnc-checkbox'
                                    label={
                                        <Typography variant='body1'>
                                            {'Please accept the'.concat(' ')}
                                            <Link
                                                target='_blank'
                                                to='bsm-terms-and-conditions'
                                                style={{ color: 'black', textDecoration: 'underline' }}
                                                aria-label={t('guestUserPage.site_terms') + ' ' + t('footer.new_window')}
                                            >
                                                {t('guestUserPage.site_terms')} ({t('footer.new_window')})
                                            </Link>
                                            {' '.concat(' to proceed in using this service').concat(' ')}
                                        </Typography>
                                    }
                                    checked={updateTick}
                                    onChange={(event) => {
                                        handleTick(event);
                                    }}
                                    variant='light.small'
                                />
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <Box display='flex' flexDirection='row-reverse' width='100%' maxWidth='600px' paddingTop='10px' borderTop='1px solid #333'>
                    <Button
                        id='gr-button-continue'
                        variant='light.primary'
                        disabled={updateDisable}
                        onClick={() => {
                            history.push('/payments-list-guest');
                        }}
                    >
                        {t('guestUserPage.continue_button')}
                    </Button>
                </Box>
            </Grid>
        </StyledDiv>
    );
};

export default GuestRegistration;
